{
  "iconUrl": "assets/icons/sprite.svg?v=3a2f18d63a"
}